import { Mutation, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class LogErrorGQL extends Mutation<LogErrorGQLResponse, LogErrorGQLVariables> {
  document = gql`
    mutation logError($data:ErrorInput!) {
      addError(data: $data) {
        message
        stackTrace
      }
    }
  `;
}

interface LogErrorGQLResponse {
  message: string;
  stackTrace?: string;
}

interface LogErrorGQLVariables {
  data: {
    message: string;
    stackTrace?: string;
  };
}
